export default __webpack_public_path__ + "ea302f2739fcbb56e0754c72ccfb49ae.png";